import { IConstants } from '../../types/constants';
import { IState } from '../../types/general';
import { SET_CONSTANTS, SET_BLOCKCHAIN_STATE } from './constants';

export const setContansAction = (state: IConstants) => ({
  type: SET_CONSTANTS,
  payload: state,
});

export const setBlockchainState = (state: IState) => ({
  type: SET_BLOCKCHAIN_STATE,
  payload: state,
});
